function dateFormatHelper() {

  switch (window.navigator.language) {
    case "de-DE":
      return "dd.mm.yy";
    case "fr-FR":
      return "dd/mm/yy";
    case "en-US":
      return "mm-dd-yy";

    default:
      return "dd.mm.yyyy";
  }

}

export {dateFormatHelper}
